// app/javascript/controllers/auto_submit_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {



    submitOnFocusOut(event) {
        // The event's target is the element losing focus.
        // Check if it's inside the current form, and if so, submit the form.
        if (this.element.contains(event.relatedTarget)) {
            console.log("THIS WAS SUBMITTED BITCH!");
            this.element.submit();
        }
    }
}